
export function exportToExcel(filename: string, data: any[]) {
  if (!data || data.length === 0) {
    alert("無資料可匯出");
    return;
  }

  // Get Headers
  const headers = Object.keys(data[0]);
  
  // Create CSV content with BOM for Excel UTF-8 support
  const csvRows: string[] = [];
  csvRows.push(headers.join(","));

  for (const row of data) {
    const values = headers.map(header => {
      let val = row[header];
      if (typeof val === 'object' && val !== null) {
         // Simplify objects/arrays for CSV
         val = JSON.stringify(val).replace(/"/g, "'");
      }
      const escaped = ('' + (val ?? '')).replace(/"/g, '""');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(","));
  }

  // Add BOM \uFEFF so Excel recognizes it as UTF-8
  const csvContent = "\uFEFF" + csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", `${filename}_${new Date().toISOString().slice(0,10)}.csv`);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
